<!--右侧组件外层框架，带滚动条-->
<template>
  <div style="height: 100%;">
    <el-scrollbar class="whaty-scroll" ref="myScrollbar" :style="{height: pageHeight + 16 + 'px'}">
      <div>
        <slot></slot>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
  import { addResizeListener, removeResizeListener } from 'element-ui/src/utils/resize-event'
  export default {
    name: 'ScrollRightFrame',
    data() {
      return {
        pageHeight: 200
      }
    },
    mounted() {
      this.$nextTick(this.update)
      addResizeListener(this.$el, this.update)
    },
    methods: {
      update() {
        if (this.pageHeight !== this.$el.offsetHeight) {
          this.$refs.myScrollbar.update()
        }
        // 设置el-scrollbar中内层div高度与最外层高度一致
        this.pageHeight = this.$el.offsetHeight
      }
    },
    beforeDestroy() {
      removeResizeListener(this.$el, this.update)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/scroll-right-frame.vue